/*!
 * Paijo Widget — chat widget milik Tipsy Tales (pengganti Qonflo)
 * Front-end murni, tanpa dependensi. UI di dalam Shadow DOM supaya CSS theme tidak bentrok.
 *
 * Kontrak server (mode "live"), semua lewat Shopify App Proxy:
 *   POST {endpoint}/chat   body: {session_id, message, choice_id?, page:{path,title}, locale}
 *     -> {ok:true, reply:string,
 *         products?:[{handle,title,price,image,variant_id,available}],        (info rekomendasi, tanpa tombol)
 *         actions?:[{type:'add_to_cart',handle,title,price,variant_id,qty,available}],  (hanya dari permintaan eksplisit customer)
 *         choices?:[{id,label,sub?}]   (pertanyaan klarifikasi: customer memilih salah satu; id = token buatan server)
 *         suggestions?:string[]}
 *     -> {ok:false, message:string}                      (rate limit, dll)
 *   Form awal (v0.3): POST {endpoint}/chat body: {session_id, profile:{name, phone?}, page, locale} (tanpa message)
 *     -> {ok:true, reply (sapaan bernama; kosong bila chat sudah berisi), reply_id, suggestions?} | {ok:false, message}
 *   Jawaban /chat boleh memuat links:[{type:'cart'|'checkout'}]; widget membuat tombolnya sendiri dari jenis (alamat tidak datang dari server).
 *   POST {endpoint}/event  body: {session_id, type, ...}  (laporan hasil add-to-cart ke monitoring)
 *   GET  {pollUrl}?sid=&after_id=   -> {ok, mode:'bot'|'human', messages:[{id,from:'admin'|'paijo',text}], last_id}
 *        (balasan admin dan pemberitahuan pergantian mode; dipanggil hanya saat widget terbuka / sesi mode admin)
 *   Alamat dapat diberikan lengkap lewat chatUrl / eventUrl / pollUrl (tanpa App Proxy). Jawaban /chat juga memuat
 *   mode ('bot'|'human') dan reply_id (id pesan Paijo yang sudah tampil langsung, agar polling tidak menampilkannya lagi).
 *
 * Prinsip keamanan/kejujuran:
 *  - Semua teks dari server dirender lewat textContent (tidak ada innerHTML) -> kebal XSS.
 *  - Link produk dibangun dari `handle` yang divalidasi, bukan dari URL kiriman server.
 *  - Tulisan "sudah masuk keranjang" HANYA muncul setelah /cart/add.js sukses DAN /cart.js
 *    membuktikan barangnya benar-benar ada di keranjang.
 *  - Tidak ada UI keranjang di widget: produk & jumlah dibaca dari permintaan customer di chat.
 *    Jumlah tidak valid/terlalu banyak TIDAK diubah diam-diam; Paijo minta customer menyebutkan ulang.
 *  - Checkout/pembayaran tetap 100% di Shopify.
 *  - Sesi chat hidup per TAB (sessionStorage): tab ditutup = chat hilang dan mulai dari awal (form nama/WA lagi).
 *    Muat ulang / pindah halaman di tab yang sama tetap melanjutkan chat. Nomor WA (wajib di form awal, v0.6.3) disimpan di sessionStorage tab ini saja,
 *    hanya untuk menawarkan "sama" saat mengisi data pengiriman; hilang saat tab ditutup atau riwayat habis. Tidak pernah dikirim lagi selain saat form awal.
 */
(function () {
  'use strict';
  if (window.__paijoWidgetLoaded) return;
  window.__paijoWidgetLoaded = true;

  var CFG = (function () {
    var d = {
      mode: 'live',            // 'live' | 'mock'
      rollout: 'all',          // 'off' | 'flag' (hanya jika ?paijo=1) | 'all'
      endpoint: '/apps/paijo', // dipakai bila chatUrl/eventUrl/pollUrl kosong: {endpoint}/chat, {endpoint}/event
      chatUrl: '',             // mis. https://monitoring.tipsytales.id/api/widget_chat.php
      eventUrl: '',            // mis. https://monitoring.tipsytales.id/api/widget_event.php
      pollUrl: '',             // mis. https://monitoring.tipsytales.id/api/widget_poll.php (kosong = tanpa polling)
      pollFastMs: 4000,        // saat mode admin dan panel terbuka
      pollSlowMs: 15000,       // saat panel terbuka tapi mode bot / panel tertutup tapi mode admin
      cssUrl: '',
      avatarUrl: '',           // foto profil Paijo (maskot panda)
      bgUrl: '',               // logo Tipsy Tales untuk latar chat (png/webp transparan)
      whatsapp: '',            // nomor WA fallback, mis. 6281230553006
      ageGate: true,           // tunggu age verifier theme lolos
      maxLen: 500,
      maxQty: 24,
      requestTimeoutMs: 30000,
      historyTtlMs: 6 * 60 * 60 * 1000,
      replyDelayMs: 3000,     // Paijo membalas setelah customer berhenti mengetik/mengirim selama sekian ms; beberapa gelembung dibalas sekaligus (0 = langsung)
      avoid: ['.m-mobile-sticky-bar', '.m-sticky-addtocart', '#scroll-to-top-button'],   // elemen tema yang menempel di layar (bar bawah, tombol ke atas): launcher naik supaya tidak menutupinya
      pauseMs: 650            // jeda "mengetik" antar gelembung saat balasan dipecah per paragraf (0 = tanpa jeda)
    };
    var u = window.PaijoWidgetConfig || {};
    for (var k in u) if (Object.prototype.hasOwnProperty.call(u, k)) d[k] = u[k];
    return d;
  })();

  /* ---------- util ---------- */
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* abaikan */ } },
    del: function (k) { try { window.localStorage.removeItem(k); } catch (e) { /* abaikan */ } }
  };
  /* Penyimpanan per tab: sessionStorage (hilang saat tab ditutup). Bila diblokir browser, jatuh ke memori (chat hilang saat dimuat ulang). */
  var tab = (function () {
    var mem = {}, live = false;
    try { window.sessionStorage.setItem('__pw_t', '1'); window.sessionStorage.removeItem('__pw_t'); live = true; } catch (e) { live = false; }
    return {
      get: function (k) { if (live) { try { return window.sessionStorage.getItem(k); } catch (e) { /* jatuh ke memori */ } } return Object.prototype.hasOwnProperty.call(mem, k) ? mem[k] : null; },
      set: function (k, v) { mem[k] = String(v); if (live) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* abaikan */ } } },
      del: function (k) { delete mem[k]; if (live) { try { window.sessionStorage.removeItem(k); } catch (e) { /* abaikan */ } } }
    };
  })();
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function shopRoot() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return typeof r === 'string' && r.charAt(0) === '/' ? r : '/';
  }
  function uuid() {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) { /* lanjut */ }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 3) | 8).toString(16);
    });
  }
  function timeoutFetch(url, opts, ms) {
    var ctl = typeof AbortController === 'function' ? new AbortController() : null;
    var t = ctl ? setTimeout(function () { ctl.abort(); }, ms) : null;
    opts = opts || {};
    if (ctl) opts.signal = ctl.signal;
    return fetch(url, opts).then(function (r) { if (t) clearTimeout(t); return r; },
      function (e) { if (t) clearTimeout(t); throw e; });
  }
  var idr = (function () {
    try { return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }); }
    catch (e) { return null; }
  })();
  function money(n) { return idr ? idr.format(n).replace(/\xA0/g, ' ') : 'Rp ' + Math.round(n); }
  function urlFor(kind) {
    var explicit = kind === 'chat' ? CFG.chatUrl : kind === 'event' ? CFG.eventUrl : CFG.pollUrl;
    if (explicit) return String(explicit);
    return kind === 'poll' ? '' : CFG.endpoint.replace(/\/$/, '') + '/' + kind;
  }
  function clamp(n, lo, hi) { n = Math.floor(Number(n)); if (!isFinite(n)) n = lo; return Math.min(hi, Math.max(lo, n)); }

  /* ---------- rollout & age gate ---------- */
  function rolloutAllowed() {
    try {
      var q = new URLSearchParams(window.location.search);
      if (q.has('paijo')) store.set('paijo_flag', q.get('paijo') === '1' ? '1' : '0');
    } catch (e) { /* abaikan */ }
    var flag = store.get('paijo_flag');
    if (flag === '0') return false;               // kill-switch pribadi: ?paijo=0
    if (CFG.rollout === 'off') return false;
    if (CFG.rollout === 'flag') return flag === '1';
    return true;
  }
  /* Mode debug (hanya untuk uji): ?paijo_debug=1 menampilkan bagaimana Paijo memahami tiap pesan. ?paijo_debug=0 mematikan. */
  var DEBUG = (function () {
    try {
      var q = new URLSearchParams(window.location.search);
      if (q.has('paijo_debug')) store.set('paijo_debug', q.get('paijo_debug') === '1' ? '1' : '0');
    } catch (e) { /* abaikan */ }
    return store.get('paijo_debug') === '1';
  })();
  var ACT_LABEL = { answer: 'JAWABAN', question: 'PERTANYAAN', request: 'PERMINTAAN', statement: 'PERNYATAAN', correction: 'KOREKSI',
    cancel: 'BATAL', vague: 'JAWABAN TIDAK JELAS', vagueqty: 'JUMLAH TIDAK PASTI', yes: 'YA', no: 'TIDAK', yes_wrong: '"IYA" TIDAK NYAMBUNG',
    chat: 'OBROLAN', checkout: 'MAU CHECKOUT', handoff: 'MINTA ADMIN', greet: 'SAPAAN AWAL' };
  function showDebug(afterEl, meta) {
    if (!DEBUG || !afterEl || !meta || typeof meta !== 'object') return;
    var act = ACT_LABEL[meta.act] || String(meta.act || '?').slice(0, 20);
    var txt = 'dipahami: ' + act + (meta.via ? ' (' + String(meta.via).slice(0, 12) + ')' : '');
    if (meta.expects) txt += ' · menunggu: ' + String(meta.expects).slice(0, 20) + (meta.kept ? ' → pertanyaan dipertahankan' : '');
    var d = el('div', 'pw-debug', txt);
    afterEl.parentNode.insertBefore(d, afterEl.nextSibling);
  }
  function ageGatePassed() {
    if (!CFG.ageGate) return true;
    if (!document.querySelector('m-age-verifier-popup')) return true;
    return /(?:^|;\s*)Minimog(?::|%3A)age-verifier-[^=]*=agreed/i.test(document.cookie);
  }

  /* ---------- validasi data dari server (tidak dipercaya) ---------- */
  function safeProduct(p) {
    if (!p || typeof p !== 'object') return null;
    var handle = String(p.handle || '');
    if (!/^[a-z0-9][a-z0-9\-_.]{0,254}$/i.test(handle)) return null;
    var vid = String(p.variant_id || '').replace(/^gid:\/\/shopify\/ProductVariant\//, '');
    if (!/^\d{5,20}$/.test(vid)) return null;
    var price = Number(p.price);
    if (!isFinite(price) || price < 0) return null;
    var image = '';
    if (typeof p.image === 'string' && (p.image.indexOf('https://cdn.shopify.com/') === 0 ||
        p.image.indexOf(window.location.origin + '/cdn/') === 0)) image = p.image;
    return {
      handle: handle,
      title: String(p.title || handle).slice(0, 200),
      price: price,
      image: image,
      variantId: vid,
      available: p.available !== false,
      qty: Number(p.qty)
    };
  }

  /* ---------- state ---------- */
  // Versi lama (v0.2) menyimpan sesi di localStorage (bertahan berjam-jam walau tab ditutup): dibersihkan, sesi kini per tab.
  store.del('paijo_w_sid'); store.del('paijo_w_hist');
  var state = {
    sid: tab.get('paijo_w_sid') || '',
    profile: null,
    history: [],
    pending: false,
    ship: null,           // pengisian data pengiriman untuk checkout: hanya di memori halaman, TIDAK pernah disimpan atau dikirim ke server
    ledger: {},           // pesanan yang dimasukkan lewat chat ini per varian {variant_id: {q: jumlah, t: judul}}; dipakai membandingkan dengan keranjang Shopify (bukan data pribadi)
    queue: [],            // gelembung customer yang menunggu dibalas (digabung jadi satu giliran)
    qTimer: null,
    again: false,
    lastSendAt: 0,
    open: false,
    mode: 'bot',
    lastId: 0,
    humanNoted: false,
    seen: {}
  };
  if (!/^[0-9a-f-]{36}$/i.test(state.sid)) { state.sid = uuid(); tab.set('paijo_w_sid', state.sid); }
  try {
    var pf = JSON.parse(tab.get('paijo_w_profile') || 'null');
    if (pf && typeof pf.n === 'string' && pf.n) state.profile = { n: pf.n.slice(0, 40), p: typeof pf.p === 'string' && /^628\d{7,11}$/.test(pf.p) ? pf.p : '' };
  } catch (e) { state.profile = null; }
  try {
    var h = JSON.parse(tab.get('paijo_w_hist') || 'null');
    if (h && Array.isArray(h.items) && Date.now() - h.ts < CFG.historyTtlMs) {
      state.history = h.items.slice(-40);
      state.lastId = Math.max(0, Math.floor(Number(h.lastId)) || 0);
      state.mode = h.mode === 'human' ? 'human' : 'bot';
    }
  } catch (e) { state.history = []; }
  if (!state.history.length) {
    // Riwayat kosong atau sudah kedaluwarsa: mulai percakapan baru dengan sesi baru. Sesi lama tidak dipakai lagi
    // (kalau dipakai, polling akan memutar ulang balasan admin lama sebagai pesan baru).
    state.sid = uuid(); tab.set('paijo_w_sid', state.sid); state.lastId = 0; state.mode = 'bot';
    if (state.profile) { state.profile = null; tab.del('paijo_w_profile'); }      // riwayat habis = chat baru dari awal, termasuk form nama
  }
  try {
    var lg = JSON.parse(tab.get('paijo_w_ledger') || 'null');
    if (lg && typeof lg === 'object' && state.history.length) {
      for (var lk in lg) if (Object.prototype.hasOwnProperty.call(lg, lk) && /^\d{5,20}$/.test(lk) && lg[lk] && Number(lg[lk].q) >= 1 && Number(lg[lk].q) <= 999) state.ledger[lk] = { q: Math.floor(Number(lg[lk].q)), t: String(lg[lk].t || '').slice(0, 120) };
    }
  } catch (e) { state.ledger = {}; }
  if (!state.history.length) tab.del('paijo_w_ledger');
  function ledgerAdd(variantId, qty, title) {
    var k = String(variantId), cur = state.ledger[k] ? state.ledger[k].q : 0;
    state.ledger[k] = { q: Math.min(999, cur + qty), t: String(title || '').slice(0, 120) };
    tab.set('paijo_w_ledger', JSON.stringify(state.ledger));
  }
  function saveProfile() { if (state.profile) tab.set('paijo_w_profile', JSON.stringify({ n: state.profile.n, p: state.profile.p || '' })); }
  function needsProfile() { return !state.profile && !state.history.length; }
  function saveHistory() {
    tab.set('paijo_w_hist', JSON.stringify({ ts: Date.now(), items: state.history.slice(-40), lastId: state.lastId, mode: state.mode }));
  }

  /* ---------- pelaporan ke monitoring ---------- */
  function report(type, data) {
    var body = { session_id: state.sid, type: type, ts: Date.now() };
    for (var k in data) if (Object.prototype.hasOwnProperty.call(data, k)) body[k] = data[k];
    if (CFG.mode === 'mock') { if (window.console) console.debug('[paijo-widget] event', body); return; }
    try {
      fetch(urlFor('event'), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body), keepalive: true, credentials: 'omit'
      }).catch(function () { /* laporan gagal tidak boleh mengganggu pelanggan */ });
    } catch (e) { /* abaikan */ }
  }

  /* Catatan ke monitoring untuk pesan yang dibuat widget sendiri (ringkasan keranjang, form & pengingat data pengiriman, link checkout), supaya riwayat di monitoring lengkap.
     Dikirim berurutan satu per satu. PENTING: jawaban customer yang berisi data pribadi (nama, HP, alamat, kota, kode pos) TIDAK pernah dikirim; hanya nama kolomnya, mis. "[Data pengiriman diisi: Nama, HP]". */
  var logChain = Promise.resolve();
  function wlog(role, text) {
    if (CFG.mode === 'mock' || !text) return;
    var body = JSON.stringify({ session_id: state.sid, type: 'widget_log', role: role === 'user' ? 'user' : 'bot', text: String(text).slice(0, 800) });
    logChain = logChain.then(function () {
      return timeoutFetch(urlFor('event'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true, credentials: 'omit' }, 8000)
        .catch(function () { /* pencatatan gagal tidak boleh mengganggu customer */ });
    }).catch(function () { /* rantai tidak boleh putus karena satu galat */ });
  }
  function sbubble(text) { var b = bubble('bot', text); wlog('bot', text); return b; }

  /* ---------- keranjang Shopify ---------- */
  function cartError(msg, status, detail) { var e = new Error(msg); e.status = status; e.detail = detail; return e; }
  function addToCart(variantId, qty) {
    var root = shopRoot();
    var added = false;      // true setelah /cart/add.js sukses: kegagalan sesudahnya berarti "belum terbukti", bukan "pasti gagal"
    return timeoutFetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
    }, 15000).then(function (res) {
      return res.json().catch(function () { return null; }).then(function (data) {
        if (!res.ok) throw cartError('add_failed', res.status, data && (data.description || data.message));
        added = true;
        return timeoutFetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }, 10000);
      });
    }).then(function (res) {
      if (!res.ok) throw cartError('verify_failed', res.status);
      return res.json();
    }).then(function (cart) {
      var items = (cart && cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        if (String(items[i].variant_id) === String(variantId) && items[i].quantity >= qty) return cart;
      }
      throw cartError('not_in_cart', 200);
    }).catch(function (e) { if (e && typeof e === 'object') e.maybeAdded = added; throw e; });
  }
  /* Penanda "sedang memasukkan ke keranjang": kalau halaman berpindah di tengah jalan, setelah dimuat ulang pelanggan diberi tahu agar mengecek keranjang. */
  function pendingSet(title, qty) { try { sessionStorage.setItem('paijo_w_pending', JSON.stringify({ t: String(title).slice(0, 120), q: qty, ts: Date.now() })); } catch (e) { /* abaikan */ } }
  function pendingClear() { try { sessionStorage.removeItem('paijo_w_pending'); } catch (e) { /* abaikan */ } }
  function pendingTake() {
    try {
      var v = JSON.parse(sessionStorage.getItem('paijo_w_pending') || 'null'); sessionStorage.removeItem('paijo_w_pending');
      if (v && typeof v.t === 'string' && Date.now() - Number(v.ts) < 5 * 60 * 1000) return v;
    } catch (e) { /* abaikan */ }
    return null;
  }
  function refreshCartUi(open) {
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: !!open } })); } catch (e) { /* abaikan */ }
  }

  /* ---------- UI ---------- */
  var host, shadow, ui = {};

  function build() {
    host = document.createElement('div');
    host.id = 'paijo-widget-host';
    shadow = host.attachShadow({ mode: 'open' });
    if (CFG.cssUrl) {
      var link = document.createElement('link');
      link.rel = 'stylesheet'; link.href = CFG.cssUrl;
      shadow.appendChild(link);
    }
    var root = el('div', 'pw-root'); ui.root = root;
    ui.launcher = el('button', 'pw-launcher');
    ui.launcher.type = 'button';
    ui.launcher.setAttribute('aria-label', 'Chat dengan Paijo');
    ui.launcher.setAttribute('aria-expanded', 'false');
    if (CFG.avatarUrl) ui.launcher.appendChild(avatarEl('pw-launcher-avatar'));
    else ui.launcher.appendChild(el('span', 'pw-launcher-icon', '🍾'));
    ui.launcher.appendChild(el('span', 'pw-launcher-text', 'Tanya Paijo'));

    ui.panel = el('section', 'pw-panel');
    ui.panel.setAttribute('role', 'dialog');
    ui.panel.setAttribute('aria-label', 'Chat dengan Paijo');
    ui.panel.hidden = true;

    var head = el('header', 'pw-head');
    head.appendChild(avatarEl('pw-avatar'));
    var ht = el('div', 'pw-head-text');
    ht.appendChild(el('div', 'pw-title', 'Paijo'));
    ht.appendChild(el('div', 'pw-sub', 'Asisten AI Tipsy Tales'));
    head.appendChild(ht);
    ui.close = el('button', 'pw-close', '×');
    ui.close.type = 'button'; ui.close.setAttribute('aria-label', 'Tutup chat');
    head.appendChild(ui.close);

    ui.log = el('div', 'pw-log');
    ui.log.setAttribute('role', 'log'); ui.log.setAttribute('aria-live', 'polite');
    ui.chips = el('div', 'pw-chips');

    ui.form = el('form', 'pw-form');
    ui.input = el('textarea', 'pw-input');
    ui.input.rows = 1; ui.input.maxLength = CFG.maxLen;
    ui.input.placeholder = 'Tulis pesan…';
    ui.input.setAttribute('aria-label', 'Pesan untuk Paijo');
    ui.send = el('button', 'pw-send', '➤');
    ui.send.type = 'submit'; ui.send.setAttribute('aria-label', 'Kirim');
    ui.form.appendChild(ui.input); ui.form.appendChild(ui.send);

    var note = el('div', 'pw-note', 'Copyright Tipsy Tales Group');

    buildPre();
    ui.panel.appendChild(head); ui.panel.appendChild(ui.pre); ui.panel.appendChild(ui.log); ui.panel.appendChild(ui.chips);
    ui.panel.appendChild(ui.form); ui.panel.appendChild(note);
    if (CFG.bgUrl) root.style.setProperty('--pw-bg', 'url("' + String(CFG.bgUrl).replace(/["'\\\n\r()]/g, '') + '")');
    root.appendChild(ui.panel); root.appendChild(ui.launcher);
    shadow.appendChild(root);
    document.body.appendChild(host);

    ui.launcher.addEventListener('click', function () { setOpen(!state.open); });
    ui.close.addEventListener('click', function () { setOpen(false); });
    ui.panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setOpen(false); ui.launcher.focus(); } });
    ui.form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
    ui.input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); submit(); }
    });
    ui.input.addEventListener('input', autosize);
  }

  /* ---------- form awal: nama (wajib) + nomor WhatsApp (opsional) ---------- */
  var NAME_RE = (function () { try { return new RegExp("^[\\p{L}\\p{M}][\\p{L}\\p{M} .'\\-]*$", 'u'); } catch (e) { return /^[A-Za-z][A-Za-z .'\-]*$/; } })();
  function checkName(v) {
    v = String(v || '').replace(/\s+/g, ' ').trim();
    if (!v) return { ok: false, msg: 'Nama wajib diisi ya.' };
    if (v.length < 2 || v.length > 40 || !NAME_RE.test(v)) return { ok: false, msg: 'Nama cukup huruf saja, 2 sampai 40 karakter ya.' };
    return { ok: true, value: v };
  }
  function checkPhone(v, req) {
    v = String(v || '').trim();
    if (!v) return req ? { ok: false, msg: 'Nomor WhatsApp wajib diisi ya. Contoh: 081234567890' } : { ok: true, value: '' };
    var d = v.replace(/[\s().\-]/g, '');
    if (!/^\+?\d+$/.test(d)) return { ok: false, msg: 'Nomor WhatsApp hanya boleh angka. Contoh: 081234567890' };
    d = d.replace(/^\+/, '');
    if (d.indexOf('62') === 0) { /* sudah kode negara */ } else if (d.charAt(0) === '0') d = '62' + d.slice(1); else if (d.charAt(0) === '8') d = '62' + d;
    if (!/^628\d{7,11}$/.test(d)) return { ok: false, msg: 'Nomor WhatsApp belum sesuai. Contoh: 081234567890' };
    return { ok: true, value: d };
  }
  function buildPre() {
    ui.pre = el('form', 'pw-pre'); ui.pre.noValidate = true; ui.pre.setAttribute('aria-label', 'Kenalan dulu');
    ui.pre.appendChild(el('div', 'pw-pre-title', 'Kenalan dulu yuk, Kak'));
    var l1 = el('label', 'pw-lbl'), l1t = el('span', 'pw-lbl-t', 'Nama '); l1t.appendChild(el('span', 'pw-req', '(wajib)')); l1.appendChild(l1t);
    ui.preName = el('input', 'pw-field'); ui.preName.type = 'text'; ui.preName.maxLength = 40; ui.preName.autocomplete = 'name'; ui.preName.placeholder = 'Nama Kakak';
    l1.appendChild(ui.preName);
    ui.preNameErr = el('div', 'pw-ferr'); ui.preNameErr.setAttribute('role', 'alert');
    var l2 = el('label', 'pw-lbl'), l2t = el('span', 'pw-lbl-t', 'Nomor WhatsApp '); l2t.appendChild(el('span', 'pw-req', '(wajib)')); l2.appendChild(l2t);
    ui.preWa = el('input', 'pw-field'); ui.preWa.type = 'tel'; ui.preWa.inputMode = 'tel'; ui.preWa.maxLength = 20; ui.preWa.autocomplete = 'tel'; ui.preWa.placeholder = '08xxxxxxxxxx';
    l2.appendChild(ui.preWa);
    ui.preWaErr = el('div', 'pw-ferr'); ui.preWaErr.setAttribute('role', 'alert');
    ui.preErr = el('div', 'pw-ferr pw-ferr-main'); ui.preErr.setAttribute('role', 'alert');
    ui.preBtn = el('button', 'pw-prebtn', 'Mulai chat'); ui.preBtn.type = 'submit';
    ui.pre.appendChild(l1); ui.pre.appendChild(ui.preNameErr); ui.pre.appendChild(l2); ui.pre.appendChild(ui.preWaErr);
    ui.pre.appendChild(ui.preErr); ui.pre.appendChild(ui.preBtn);
    function clr() { ui.preNameErr.textContent = ''; ui.preWaErr.textContent = ''; ui.preErr.textContent = ''; }
    ui.preName.addEventListener('input', clr); ui.preWa.addEventListener('input', clr);
    ui.pre.addEventListener('submit', function (e) { e.preventDefault(); submitProfile(); });
  }
  function showPre(on) {
    ui.panel.classList.toggle('pw-prechat', !!on);
  }
  function submitProfile() {
    if (state.pending) return;
    var n = checkName(ui.preName.value), w = checkPhone(ui.preWa.value, true);
    ui.preNameErr.textContent = n.ok ? '' : n.msg; ui.preWaErr.textContent = w.ok ? '' : w.msg; ui.preErr.textContent = '';
    if (!n.ok) { ui.preName.focus(); return; }
    if (!w.ok) { ui.preWa.focus(); return; }
    state.pending = true; ui.preBtn.disabled = true; ui.preBtn.textContent = 'Menghubungkan…';
    postChat({ profile: { name: n.value, phone: w.value } }).then(function (data) {
      state.profile = { n: n.value, p: w.value }; saveProfile();
      if (typeof data.reply_id === 'number' && data.reply_id > 0) state.seen[Math.floor(data.reply_id)] = 1;
      showPre(false);
      var hi = typeof data.reply === 'string' && data.reply ? data.reply.slice(0, 600) : '';
      if (hi) {
        bubble('bot', hi); state.history.push({ r: 'bot', t: hi }); saveHistory();
      } else { startConversation(); }
      ui.preName.value = ''; ui.preWa.value = '';
      setTimeout(function () { ui.input.focus(); scrollDown(); }, 30);
    }).catch(function (err) {
      ui.preErr.textContent = err && err.userMessage ? err.userMessage : 'Belum bisa terhubung ke Paijo. Coba lagi sebentar ya.';
    }).then(function () {
      state.pending = false; ui.preBtn.disabled = false; ui.preBtn.textContent = 'Mulai chat';
    });
  }

  function avatarEl(cls) {
    var wrap = el('span', cls);
    if (CFG.avatarUrl) {
      var img = document.createElement('img');
      img.src = CFG.avatarUrl; img.alt = ''; img.decoding = 'async'; img.draggable = false;
      img.addEventListener('error', function () { img.remove(); wrap.textContent = 'P'; wrap.classList.add('pw-av-fallback'); });
      wrap.appendChild(img);
    } else { wrap.textContent = 'P'; wrap.classList.add('pw-av-fallback'); }
    return wrap;
  }
  function autosize() {
    ui.input.style.height = 'auto';
    ui.input.style.height = Math.min(ui.input.scrollHeight, 96) + 'px';
  }
  function setOpen(v) {
    state.open = !!v;
    ui.panel.hidden = !state.open;
    ui.launcher.setAttribute('aria-expanded', String(state.open));
    ui.launcher.classList.toggle('pw-hidden-mobile', state.open);
    if (state.open) {
      var pre = needsProfile();
      showPre(pre);
      if (!pre && !ui.log.childNodes.length) startConversation();
      ui.launcher.classList.remove('pw-unread');
      setTimeout(function () { (pre ? ui.preName : ui.input).focus(); scrollDown(); }, 30);
      report('widget_open', {});
      if (urlFor('poll') && state.history.length) { if (pollTimer) clearTimeout(pollTimer); pollTimer = setTimeout(pollOnce, 600); }
    } else { reschedulePoll(); }
    syncViewport();
  }
  function scrollDown() { ui.log.scrollTop = ui.log.scrollHeight; }

  /* Layar penuh di HP: ikuti tinggi area yang benar-benar terlihat (keyboard layar di iOS/Android tidak menutupi kolom ketik). */
  function syncViewport() {
    try {
      var vv = window.visualViewport;
      if (!vv || !ui.panel) return;
      var full = window.matchMedia && window.matchMedia('(max-width: 520px), (max-height: 560px)').matches;
      if (full && state.open) {
        ui.panel.style.setProperty('--pw-vh', Math.round(vv.height) + 'px');
        ui.panel.style.setProperty('--pw-top', Math.round(vv.offsetTop) + 'px');
        scrollDown();
      } else {
        ui.panel.style.removeProperty('--pw-vh'); ui.panel.style.removeProperty('--pw-top');
      }
    } catch (e) { /* peramban tanpa visualViewport: pakai 100dvh dari CSS */ }
  }
  /* Launcher tidak boleh menutupi bar bawah tema (menu HP, "Add to cart" lengket) atau tombol ke atas:
     bila bertabrakan, root dinaikkan lewat --pw-lift. Dipantau saat scroll/resize/ganti halaman. */
  var liftTimer = null, liftLast = -1;
  function updateLift() {
    try {
      if (!ui.root || !host || host.style.display === 'none') return;
      var sels = Array.isArray(CFG.avoid) ? CFG.avoid : [];
      var vw = window.innerWidth, vh = window.innerHeight, size = 52, gap = 10, base = vw <= 520 ? 12 : 16;
      var right = base, left = vw - base - 160;                  // kolom launcher (perkiraan lebar 160px) di sisi kanan
      var obs = [];
      sels.forEach(function (sel) {
        var nodes; try { nodes = document.querySelectorAll(sel); } catch (e) { return; }
        for (var i = 0; i < nodes.length; i++) {
          var cs = window.getComputedStyle(nodes[i]);
          if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.5 || cs.position !== 'fixed') continue;
          var r = nodes[i].getBoundingClientRect();
          if (r.width < 1 || r.height < 1 || r.bottom <= 0 || r.top >= vh || r.right < left || r.left > vw - right) continue;
          obs.push({ lo: vh - r.bottom, hi: vh - r.top });          // jarak dari dasar layar
        }
      });
      var want = base;
      for (var k = 0; k < 5; k++) {
        var moved = false;
        for (var j = 0; j < obs.length; j++) {
          if (want < obs[j].hi + 8 && want + size > obs[j].lo - 8 && want < obs[j].hi + gap) { want = obs[j].hi + gap; moved = true; }
        }
        if (!moved) break;
      }
      want = Math.min(want, Math.max(base, vh - size - 80));       // jangan sampai keluar layar
      var lift = Math.max(0, Math.round(want - base));
      if (lift !== liftLast) { liftLast = lift; ui.root.style.setProperty('--pw-lift', lift + 'px'); }
    } catch (e) { /* abaikan: launcher tetap di posisi awal */ }
  }
  function watchLift() {
    var t = null;
    function soon() { if (t) return; t = setTimeout(function () { t = null; updateLift(); }, 80); }
    window.addEventListener('scroll', soon, { passive: true });
    window.addEventListener('resize', soon);
    window.addEventListener('orientationchange', soon);
    liftTimer = setInterval(updateLift, 700);                    // bar tema bisa muncul/hilang tanpa scroll (transisi, ganti varian)
    updateLift();
  }

  function watchViewport() {
    try {
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', syncViewport);
        window.visualViewport.addEventListener('scroll', syncViewport);
      }
      window.addEventListener('orientationchange', function () { setTimeout(syncViewport, 200); });
    } catch (e) { /* abaikan */ }
  }

  function rich(node, text) {
    var re = /\*([^*\n]{1,80})\*/g, last = 0, m;
    while ((m = re.exec(text))) {
      if (m.index > last) node.appendChild(document.createTextNode(text.slice(last, m.index)));
      node.appendChild(el('strong', null, m[1]));
      last = re.lastIndex;
    }
    if (last < text.length) node.appendChild(document.createTextNode(text.slice(last)));
  }
  /* Avatar hanya di pesan bot pertama dalam satu rangkaian; sisanya diberi ruang kosong agar sejajar. */
  function botGutter() {
    var prev = ui.log.lastElementChild;
    var continuing = prev && prev.classList && prev.classList.contains('pw-bot');
    return continuing ? el('span', 'pw-bav pw-bav-gap') : avatarEl('pw-bav');
  }
  function bubble(role, text) {
    var b = el('div', 'pw-msg pw-' + role);
    if (role.indexOf('bot') === 0) b.appendChild(botGutter());
    var inner = el('div', 'pw-bubble');
    rich(inner, String(text));
    b.appendChild(inner);
    ui.log.appendChild(b);
    scrollDown();
    return b;
  }

  /* Balasan admin manusia: tampil dengan label supaya customer tahu bukan Paijo. */
  function adminBubble(text) {
    var b = bubble('bot pw-admin', text);
    var inner = b.querySelector('.pw-bubble');
    if (inner) inner.insertBefore(el('div', 'pw-admin-tag', 'Admin Tipsy Tales'), inner.firstChild);
    return b;
  }

  /* ---------- polling balasan admin ---------- */
  var pollTimer = null;
  function setMode(m) {
    m = m === 'human' ? 'human' : 'bot';
    if (m === state.mode) return;
    state.mode = m;
    if (m === 'bot') state.humanNoted = false;
    saveHistory();
    reschedulePoll();
  }
  function pollDelay() {
    if (CFG.mode === 'mock' || !urlFor('poll')) return 0;
    var human = state.mode === 'human';
    if (state.open) return human ? CFG.pollFastMs : CFG.pollSlowMs;
    return human ? CFG.pollSlowMs : 0;
  }
  function reschedulePoll() {
    if (pollTimer) { clearTimeout(pollTimer); pollTimer = null; }
    var d = pollDelay();
    if (d) pollTimer = setTimeout(pollOnce, d);
  }
  function pollOnce() {
    pollTimer = null;
    if (document.hidden || !state.history.length || !ui.log) { reschedulePoll(); return; }
    timeoutFetch(urlFor('poll') + '?sid=' + encodeURIComponent(state.sid) + '&after_id=' + state.lastId,
      { credentials: 'omit', headers: { 'Accept': 'application/json' } }, 10000)
      .then(function (r) { return r.json().catch(function () { return null; }).then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (x) { if (x.ok && x.d && x.d.ok === true) applyPoll(x.d); })
      .catch(function () { /* jaringan putus: coba lagi di putaran berikutnya */ })
      .then(reschedulePoll);
  }
  function applyPoll(d) {
    var list = Array.isArray(d.messages) ? d.messages.slice(0, 50) : [];
    var fresh = list.filter(function (m) {
      if (!m || typeof m !== 'object') return false;
      var id = Number(m.id);
      return isFinite(id) && id > 0 && !state.seen[id] && typeof m.text === 'string' && m.text && (m.from === 'admin' || m.from === 'paijo');
    });
    if (fresh.length && !ui.log.childNodes.length) startConversation();   // pulihkan riwayat dulu agar urutan benar
    fresh.forEach(function (m) {
      state.seen[Number(m.id)] = 1;
      var text = m.text.slice(0, 2000);
      if (m.from === 'admin') {
        adminBubble(text); state.history.push({ r: 'bot', t: text, adm: true });
        if (!state.open) ui.launcher.classList.add('pw-unread');
      } else { bubble('bot', text); state.history.push({ r: 'bot', t: text }); }
    });
    if (typeof d.last_id === 'number' && isFinite(d.last_id)) state.lastId = Math.max(state.lastId, Math.floor(d.last_id));
    setMode(d.mode);
    saveHistory();
  }

  /* Baris info produk (rekomendasi) — TANPA tombol/stepper/keranjang. */
  function productRow(prod) {
    var card = el('div', 'pw-card');
    var top = el('div', 'pw-card-top');
    if (prod.image) {
      var img = el('img', 'pw-card-img'); img.src = prod.image; img.alt = prod.title;
      img.loading = 'lazy'; img.referrerPolicy = 'no-referrer';
      top.appendChild(img);
    }
    var info = el('div', 'pw-card-info');
    var a = el('a', 'pw-card-title', prod.title);
    a.href = shopRoot() + 'products/' + encodeURIComponent(prod.handle);
    a.target = '_blank'; a.rel = 'noopener';
    info.appendChild(a);
    info.appendChild(el('div', 'pw-card-price', money(prod.price)));
    if (!prod.available) info.appendChild(el('div', 'pw-card-soldout', 'Stok habis'));
    top.appendChild(info);
    card.appendChild(top);
    return card;
  }
  function showProducts(list) {
    if (!list || !list.length) return;
    var wrap = el('div', 'pw-cards');
    for (var i = 0; i < list.length; i++) wrap.appendChild(productRow(list[i]));
    ui.log.appendChild(wrap);
    scrollDown();
  }

  /* Permintaan tambah-ke-keranjang yang berasal dari chat customer (produk + jumlah
     disebut customer, diterjemahkan server). Widget memvalidasi, menjalankan,
     lalu hanya melapor sukses jika keranjang Shopify membuktikannya. */
  function runAction(act) {
    var prod = safeProduct(act);
    if (!prod || act.type !== 'add_to_cart') return Promise.resolve();
    var qty = prod.qty;
    if (!(qty >= 1 && qty <= CFG.maxQty && qty === Math.floor(qty))) {
      var t = 'Jumlahnya belum bisa kupastikan atau terlalu banyak untuk dimasukkan lewat chat. ' +
        'Boleh sebutkan jumlahnya lagi (maks. ' + CFG.maxQty + ')?';
      bubble('bot', t); wlog('bot', t); state.history.push({ r: 'bot', t: t }); saveHistory();
      report('add_to_cart_result', { ok: false, variant_id: prod.variantId, handle: prod.handle, qty: act.qty, error: 'invalid_qty' });
      return Promise.resolve();
    }
    if (!prod.available) {
      var t0 = 'Maaf, ' + prod.title + ' lagi habis, jadi belum bisa dimasukkan ke keranjang.';
      bubble('bot', t0); wlog('bot', t0); state.history.push({ r: 'bot', t: t0 }); saveHistory();
      report('add_to_cart_result', { ok: false, variant_id: prod.variantId, handle: prod.handle, qty: qty, error: 'unavailable' });
      return Promise.resolve();
    }
    pendingSet(prod.title, qty);
    return addToCart(prod.variantId, qty).then(function (cart) {
      pendingClear(); ledgerAdd(prod.variantId, qty, prod.title);
      var t1 = '✓ ' + qty + '× ' + prod.title + ' sudah masuk keranjang.';
      bubble('bot pw-added', t1); wlog('bot', t1); state.history.push({ r: 'bot', t: t1 }); saveHistory();
      refreshCartUi(false);
      report('add_to_cart_result', { ok: true, variant_id: prod.variantId, handle: prod.handle, qty: qty, cart_count: cart && cart.item_count });
    }).catch(function (err) {
      pendingClear();
      var t2 = err && err.maybeAdded
        ? 'Hmm, ' + qty + '× ' + prod.title + ' kemungkinan sudah masuk, tapi aku belum bisa memastikannya. Cek ikon keranjang dulu ya sebelum menambah lagi.'
        : err && err.status === 422
        ? 'Maaf, ' + qty + '× ' + prod.title + ' tidak bisa ditambahkan (stok mungkin kurang). Mau kurangi jumlahnya atau pilih yang lain?'
        : 'Maaf, ' + prod.title + ' belum berhasil masuk keranjang — belum ada yang ditambahkan. Coba lagi ya.';
      bubble('bot pw-error', t2); wlog('bot', t2); state.history.push({ r: 'bot', t: t2, err: true }); saveHistory();
      report('add_to_cart_result', {
        ok: false, variant_id: prod.variantId, handle: prod.handle, qty: qty,
        status: err && err.status || 0, error: (err && err.maybeAdded ? 'unverified:' : '') + (err && err.message || 'unknown'), detail: err && err.detail ? String(err.detail).slice(0, 200) : ''
      });
    });
  }
  function runActions(list) {
    var bad = (Array.isArray(list) ? list : []).filter(function (a) { return a && a.type === 'add_to_cart' && !safeProduct(a); }).length;
    if (bad) {
      var tb = 'Maaf, ada produk yang belum bisa kumasukkan ke keranjang dari chat. Coba buka halaman produknya langsung ya.';
      bubble('bot pw-error', tb); wlog('bot', tb); state.history.push({ r: 'bot', t: tb, err: true }); saveHistory();
      report('add_to_cart_result', { ok: false, error: 'invalid_action' });
    }
    var seen = {}, acts = (Array.isArray(list) ? list : []).filter(function (a) {
      // validasi dulu, baru buang duplikat -> aksi tidak valid tidak boleh "memakan" slot aksi valid
      if (!a || a.type !== 'add_to_cart' || !safeProduct(a)) return false;
      var k = String(a.variant_id); if (seen[k]) return false; seen[k] = 1; return true;
    }).slice(0, 5);
    return acts.reduce(function (p, a) { return p.then(function () { return runAction(a); }); }, Promise.resolve());
  }
  /* v0.4: tidak ada tombol saran/pilihan. Paijo berbicara lewat teks saja; customer menjawab dengan mengetik. */
  function setChips() { if (ui.chips) ui.chips.textContent = ''; }
  function typing(on) {
    var t = ui.log.querySelector('.pw-typing');
    if (on && !t) {
      t = el('div', 'pw-msg pw-bot pw-typing');
      t.appendChild(botGutter());
      var b = el('div', 'pw-bubble'); b.setAttribute('aria-label', 'Paijo sedang mengetik');
      b.appendChild(el('span', 'pw-dot')); b.appendChild(el('span', 'pw-dot')); b.appendChild(el('span', 'pw-dot'));
      t.appendChild(b); ui.log.appendChild(t); scrollDown();
    } else if (!on && t) { t.remove(); }
  }

  function errorBubble(msg) {
    var b = bubble('bot pw-error', msg);
    if (CFG.whatsapp && /^\d{8,15}$/.test(String(CFG.whatsapp))) {
      var a = el('a', 'pw-wa', 'Chat via WhatsApp');
      a.href = 'https://wa.me/' + CFG.whatsapp; a.target = '_blank'; a.rel = 'noopener';
      var inner = b.querySelector('.pw-bubble') || b;
      inner.appendChild(document.createElement('br'));
      inner.appendChild(a);
    }
  }

  function startConversation() {
    if (state.history.length) {
      state.history.forEach(function (m) {
        if (m.r === 'user') bubble('user', m.t);
        else if (m.adm) adminBubble(m.t);
        else if (m.err) bubble('bot pw-error', m.t);
        else { bubble('bot', m.t); showProducts((m.p || []).map(safeProduct).filter(Boolean)); }
      });
    } else {
      bubble('bot', 'Halo' + (state.profile ? ', Kak ' + state.profile.n.split(' ')[0] : '') + '! Aku *Paijo*, asisten AI Tipsy Tales. Lagi cari minuman buat apa hari ini?');
    }
  }

  /* ---------- kirim pesan ---------- */
  function postChat(extra) {
    if (CFG.mode === 'mock') {       // uji tampilan tanpa server: sapaan palsu untuk form awal
      if (extra.profile) return Promise.resolve({ ok: true, reply: 'Halo, Kak ' + String(extra.profile.name).split(' ')[0] + '! Aku Paijo dari Tipsy Tales. Lagi cari minuman apa nih?' });
      if (!window.PaijoWidgetMock) return Promise.reject(new Error('mock_missing'));
      return window.PaijoWidgetMock.reply(extra.message, extra.choice_id);
    }
    var body = { nb: 1, ship: 1, cart: hasAddedInChat() ? 1 : 0, session_id: state.sid, page: { path: window.location.pathname, title: String(document.title || '').slice(0, 120) }, locale: document.documentElement.lang || '' };
    for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) body[k] = extra[k];
    return timeoutFetch(urlFor('chat'), {
      method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }, CFG.requestTimeoutMs).then(function (res) {
      return res.json().catch(function () { return null; }).then(function (data) {
        if (!res.ok || !data || data.ok === false) {
          var e = new Error('server'); e.status = res.status;
          e.userMessage = data && typeof data.message === 'string' ? data.message.slice(0, 300) : '';
          throw e;
        }
        return data;
      });
    });
  }
  function askServer(message) { return postChat({ message: message }); }

  /* Tautan belanja sebagai teks biasa (bukan tombol): jenis dari server ('cart' | 'checkout'), alamatnya dibuat di sini dari akar toko. Checkout/bayar tetap di Shopify. */
  function showLinks(list) {
    var inner = null, seen = {};
    (Array.isArray(list) ? list : []).slice(0, 2).forEach(function (l) {
      var t = l && l.type;
      if ((t !== 'cart' && t !== 'checkout') || seen[t]) return;
      seen[t] = 1;
      if (!inner) inner = el('div', 'pw-bubble');
      else inner.appendChild(document.createTextNode('  ·  '));
      var a = el('a', 'pw-textlink', t === 'cart' ? 'Lihat keranjang' : 'Checkout sekarang');
      a.href = shopRoot() + t;
      inner.appendChild(a);
    });
    if (!inner) return;
    var b = el('div', 'pw-msg pw-bot');
    b.appendChild(botGutter()); b.appendChild(inner);
    ui.log.appendChild(b); scrollDown();
    wlog('bot', '[Tautan ditampilkan: ' + inner.textContent.replace(/\s*·\s*/g, ' · ').trim() + ']');
  }


  /* ---------- isi otomatis checkout: data pengiriman ditanyakan di browser ---------- */
  /* Alasan dibuat di widget, bukan di server: alamat & nomor HP customer tidak boleh ikut tercatat di log chat atau database Paijo.
     Semua jawaban hanya hidup di memori halaman ini (state.ship), lalu dipakai sekali untuk menyusun tautan checkout Shopify.
     Gelembung pengisian tidak disimpan ke riwayat (sessionStorage). Ke monitoring hanya dikirim hasilnya (terisi / dilewati) dan catatan tanpa data pribadi (lihat wlog). */
  function hasAddedInChat() {
    for (var i = 0; i < state.history.length; i++) { var m = state.history[i]; if (m && m.r === 'bot' && typeof m.t === 'string' && m.t.indexOf('✓ ') === 0) return true; }
    return false;
  }
  var PROVINCES = [
    ['Aceh', 'aceh|nad|nanggroe aceh darussalam|daerah istimewa aceh'], ['North Sumatra', 'sumatera utara|sumatra utara|sumut'],
    ['West Sumatra', 'sumatera barat|sumatra barat|sumbar'], ['Riau', 'riau'], ['Riau Islands', 'kepulauan riau|kepri|kep riau'], ['Jambi', 'jambi'],
    ['South Sumatra', 'sumatera selatan|sumatra selatan|sumsel'], ['Bangka–Belitung Islands', 'bangka belitung|kepulauan bangka belitung|kep bangka belitung|babel'],
    ['Bengkulu', 'bengkulu'], ['Lampung', 'lampung'], ['Jakarta', 'jakarta|dki jakarta|dki|jakarta raya|daerah khusus ibukota jakarta'], ['Banten', 'banten'],
    ['West Java', 'jawa barat|jabar'], ['Central Java', 'jawa tengah|jateng'], ['Yogyakarta', 'yogyakarta|yogya|jogja|diy|di yogyakarta|daerah istimewa yogyakarta'],
    ['East Java', 'jawa timur|jatim'], ['Bali', 'bali'], ['West Nusa Tenggara', 'nusa tenggara barat|ntb'], ['East Nusa Tenggara', 'nusa tenggara timur|ntt'],
    ['West Kalimantan', 'kalimantan barat|kalbar'], ['Central Kalimantan', 'kalimantan tengah|kalteng'], ['South Kalimantan', 'kalimantan selatan|kalsel'],
    ['East Kalimantan', 'kalimantan timur|kaltim'], ['North Kalimantan', 'kalimantan utara|kaltara'], ['North Sulawesi', 'sulawesi utara|sulut'],
    ['Central Sulawesi', 'sulawesi tengah|sulteng'], ['South Sulawesi', 'sulawesi selatan|sulsel'], ['Southeast Sulawesi', 'sulawesi tenggara|sultra'],
    ['Gorontalo', 'gorontalo'], ['West Sulawesi', 'sulawesi barat|sulbar'], ['Maluku', 'maluku'], ['North Maluku', 'maluku utara|malut'],
    ['West Papua', 'papua barat|pabar'], ['Papua', 'papua']
  ];
  function normWords(v) { return String(v || '').toLowerCase().replace(/\bprovinsi\b|\bprov\b/g, ' ').replace(/[.,;:()\/]/g, ' ').replace(/\s+/g, ' ').trim(); }
  function provinceName(v) {
    var t = normWords(v);
    if (!t) return null;
    for (var i = 0; i < PROVINCES.length; i++) { if (PROVINCES[i][1].split('|').indexOf(t) >= 0) return PROVINCES[i][0]; }
    return null;
  }
  var SKIP_RE = /^(lewati|skip|lewat|gak ada|ga ada|nggak ada|tidak ada|ngga ada|nope|-)$/i;
  var SAMA_RE = /^(sama|sama aja|sama saja|sama kak|nomor ini|nomor tadi|itu)$/i;
  var SHIP_CANCEL_RE = /^(batal|cancel|nggak jadi|gak jadi|ga jadi|tidak jadi|stop|keluar|isi sendiri|lewati semua|skip semua|isi di checkout|isi manual)$/i;
  var SHIP_RESUME_RE = /^(lanjut|lanjutkan|lanjut isi|lanjut isi data|isi data|lanjut isi data pengiriman|ya lanjut|oke lanjut)$/i;
  var SHIP_YES_RE = /^(ya|iya|yap|yes|yup|sudah|sudah benar|benar|betul|oke|ok|sip|gas|lanjut|buka checkout|checkout)$/i;
  function cleanLine(v, max) { return String(v || '').replace(/[\x00-\x1F\x7F]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, max); }
  var SHIP_STEPS = [
    { k: 'name', mode: 'text', ask: function () {
        return 'Atas nama siapa penerimanya, Kak? Tulis nama lengkap ya.' + (state.profile ? ' Kalau sama dengan "' + state.profile.n + '", ketik "sama".' : '');
      }, parse: function (v) {
        var t = cleanLine(v, 60);
        if (state.profile && /^(sama|sama aja|sama saja|sama kak|nama saya|itu)$/i.test(t)) t = state.profile.n;
        var c = checkName(t);
        if (!c.ok) return { ok: false, msg: c.msg };
        var w = c.value.split(' ');
        return { ok: true, set: w.length === 1 ? { first: '', last: w[0], name: c.value } : { first: w.slice(0, -1).join(' '), last: w[w.length - 1], name: c.value } };
      } },
    { k: 'phone', mode: 'tel', ask: function () {
        var p = state.profile && state.profile.p;
        return 'Nomor HP/WhatsApp penerima? Dipakai kurir untuk menghubungi. Contoh: 081234567890' +
          (p ? '\nKalau sama dengan nomor yang tadi Kakak isi (berakhiran ' + p.slice(-4) + '), ketik "sama".' : '');
      }, parse: function (v) {
        if (state.profile && state.profile.p && SAMA_RE.test(cleanLine(v, 40))) v = state.profile.p;
        var c = checkPhone(v);
        if (!c.ok) return { ok: false, msg: c.msg };
        if (!c.value) return { ok: false, msg: 'Nomor HP penerima perlu diisi supaya kurir bisa menghubungi. Contoh: 081234567890' };
        return { ok: true, set: { phone: '+' + c.value, phoneShow: '0' + c.value.slice(2) } };
      } },
    { k: 'email', mode: 'email', optional: true, ask: function () { return 'Email untuk bukti pesanan? Boleh dilewati, ketik "lewati".'; }, parse: function (v) {
        var t = cleanLine(v, 120);
        if (SKIP_RE.test(t)) return { ok: true, set: { email: '' } };
        if (!/^[^\s@]{1,64}@[^\s@.]+(\.[^\s@.]+)+$/.test(t)) return { ok: false, msg: 'Formatnya belum seperti email, Kak. Contoh: nama@gmail.com, atau ketik "lewati".' };
        return { ok: true, set: { email: t } };
      } },
    { k: 'addr', mode: 'text', ask: function () { return 'Alamat lengkapnya, Kak? Jalan, nomor rumah, RT/RW, dan patokan kalau ada.'; }, parse: function (v) {
        var t = cleanLine(v, 200);
        if (t.length < 6 || !/[A-Za-z]/.test(t)) return { ok: false, msg: 'Alamatnya kurang lengkap, Kak. Tulis nama jalan dan nomornya ya.' };
        return { ok: true, set: { addr: t } };
      } },
    { k: 'district', mode: 'text', optional: true, ask: function () { return 'Kecamatannya? Boleh dilewati, ketik "lewati".'; }, parse: function (v) {
        var t = cleanLine(v, 60).replace(/^(kecamatan|kec\.?)\s+/i, '');
        if (SKIP_RE.test(t)) return { ok: true, set: { district: '' } };
        if (t.length < 2 || !/[A-Za-z]/.test(t)) return { ok: false, msg: 'Tulis nama kecamatannya, atau ketik "lewati".' };
        return { ok: true, set: { district: t } };
      } },
    { k: 'city', mode: 'text', ask: function () { return 'Kota atau kabupatennya?'; }, parse: function (v) {
        var t = cleanLine(v, 60).replace(/^(kota|kabupaten|kab\.?)\s+/i, '');
        if (t.length < 2 || !/[A-Za-z]/.test(t)) return { ok: false, msg: 'Tulis nama kota atau kabupatennya ya, Kak. Contoh: Surabaya' };
        return { ok: true, set: { city: t } };
      } },
    { k: 'prov', mode: 'text', optional: true, ask: function () { return 'Provinsinya? Contoh: Jawa Timur. Boleh dilewati, ketik "lewati".'; }, parse: function (v) {
        var t = cleanLine(v, 60);
        if (SKIP_RE.test(t)) return { ok: true, set: { prov: '', provShow: '' } };
        var pn = provinceName(t);
        if (!pn) return { ok: false, msg: 'Provinsinya belum kukenali, Kak. Tulis seperti "Jawa Timur" atau "DKI Jakarta", atau ketik "lewati" untuk memilih sendiri di checkout.' };
        return { ok: true, set: { prov: pn, provShow: t.replace(/\b\w/g, function (c) { return c.toUpperCase(); }) } };
      } },
    { k: 'zip', mode: 'numeric', ask: function () { return 'Kode posnya (5 angka)?'; }, parse: function (v) {
        var t = String(v || '').replace(/\s+/g, '');
        if (!/^\d{5}$/.test(t)) return { ok: false, msg: 'Kode pos harus 5 angka, Kak. Contoh: 60273' };
        return { ok: true, set: { zip: t } };
      } }
  ];
  var SHIP_FIELD_ALIAS = [
    [/^(nama|penerima)\b/, 0], [/^(hp|no hp|nomor hp|telepon|telpon|telp|wa|whatsapp|nomor|no|nomor wa|nomor telepon)\b/, 1], [/^(email|e-mail|surel)\b/, 2],
    [/^(alamat|jalan)\b/, 3], [/^(kecamatan|kec)\b/, 4], [/^(kota|kabupaten|kab)\b/, 5], [/^(provinsi|prov)\b/, 6], [/^(kode ?pos|pos|zip)\b/, 7]
  ];
  function shipInputMode(m) { try { ui.input.inputMode = m || 'text'; } catch (e) { /* abaikan */ } }
  function shipEnd() { if (state.ship && state.ship.timer) clearTimeout(state.ship.timer); state.ship = null; shipInputMode('text'); }
  function newShip(cart) { return { d: {}, cart: cart, clean: false, keep: false, recap: false, editing: false, choose: false, steps: false, step: 0, paused: false, hinted: false, busy: false, timer: null, tip: false, bad: [] }; }
  /* ---- pengisian data pengiriman: customer memilih dulu (satu per satu di chat, atau isi sendiri di halaman pembayaran Shopify). Pilihan satu per satu: Paijo bertanya satu isian per pesan. ---- */
  function shipChoose(intro) {
    var S = state.ship; if (!S) return;
    S.choose = true; S.steps = false; S.clean = false; S.recap = false; S.editing = false; shipInputMode('text');
    sbubble((intro ? intro + '\n\n' : '') + 'Data pengirimannya mau diisi bagaimana, Kak?\n1. Satu per satu di sini, Paijo yang tanya.\n2. Isi sendiri di link pembayaran (halaman Shopify).\n\nKetik 1 atau 2 ya.');
  }
  function shipAsk(prefix) {
    var S = state.ship; if (!S) return;
    var st = SHIP_STEPS[S.step];
    shipInputMode(st.mode);
    sbubble((prefix ? prefix + ' ' : '') + st.ask());
  }
  /* Cari isian pertama yang belum terisi (yang opsional dan sudah dilewati dianggap terisi), tanyakan; kalau semua sudah terisi, lanjut ke ringkasan. */
  function shipNextStep(intro) {
    var S = state.ship; if (!S) return;
    S.choose = false; S.steps = true; S.clean = false; S.recap = false; S.editing = false;
    for (var i = 0; i < SHIP_STEPS.length; i++) {
      if (S.d[SHIP_STEPS[i].k] === undefined) { S.step = i; shipAsk(intro); return; }
    }
    shipRecap();
  }
  var LABEL_SRC = '(^|[\\s,;])(nama(?: lengkap| penerima)?|penerima|hp|no\\.? ?hp|nomor hp|no\\.? ?telepon|nomor telepon|telepon|telpon|telp|wa|no\\.? ?wa|nomor wa|whatsapp|email|e-mail|surel|alamat(?: lengkap)?|jalan|kecamatan|kec|kota(?:\\/kabupaten)?|kabupaten|kab|provinsi|prov|kode ?pos|pos|zip)(?:\\s*\\([^)]*\\))?\\s*[:=]';
  function fieldIndex(label) {
    var t = String(label || '').toLowerCase().replace(/\./g, '').replace(/\s+/g, ' ').trim().replace(/^no ?(hp|wa|telepon)$/, 'hp');
    for (var i = 0; i < SHIP_FIELD_ALIAS.length; i++) if (SHIP_FIELD_ALIAS[i][0].test(t)) return SHIP_FIELD_ALIAS[i][1];
    return -1;
  }
  /* Memecah satu pesan menjadi isian berlabel ("Alamat: ...") dan sisa tanpa label. Label wajib memakai titik dua supaya kata di dalam alamat tidak salah dipotong. */
  function splitFields(text) {
    var re = new RegExp(LABEL_SRC, 'gi'), marks = [], m;
    while ((m = re.exec(text))) marks.push({ s: m.index + m[1].length, e: m.index + m[0].length, label: m[2] });
    if (!marks.length) return { labeled: [], loose: String(text).trim() };
    var out = [];
    for (var i = 0; i < marks.length; i++) {
      var idx = fieldIndex(marks[i].label);
      var val = text.slice(marks[i].e, i + 1 < marks.length ? marks[i + 1].s : text.length).replace(/^\s+|[\s,;]+$/g, '');
      if (idx >= 0) out.push({ idx: idx, val: val });
    }
    return { labeled: out, loose: text.slice(0, marks[0].s).replace(/[\s,;]+$/g, '').trim() };
  }
  var ADDR_HINT = /\d|\b(jl|jln|jalan|gang|gg|blok|komplek|kompleks|perum|perumahan|dusun|desa|kel|kelurahan|rt|rw)\b/i;
  var LOOSE_NOISE = /^(ya|iya|yap|ok|oke|sip|gas|siap|baik|tidak|nggak|gak|ga|nanti|bentar|sebentar|tunggu|halo|hai|makasih|terima kasih|thanks|tes|test)$/i;
  /* Tebakan untuk teks TANPA label (customer mengisi satu per satu): -1 = tidak tahu, -2 = abaikan. */
  function guessIdx(c, S) {
    var d = S.d, t = cleanLine(c, 200);
    if (!t) return -2;
    if (SKIP_RE.test(t) || LOOSE_NOISE.test(t)) return -2;
    if (/^[^\s@]{1,64}@[^\s@.]+(\.[^\s@.]+)+$/.test(t)) return 2;
    var dd = t.replace(/[\s().\-]/g, '');
    if (/^\+?\d+$/.test(dd)) return dd.charAt(0) !== '+' && dd.length <= 7 ? 7 : 1;      // angka pendek = kode pos (kalau salah panjang, diberi tahu); angka panjang = nomor HP
    if (state.profile && !d.name && /^(sama|sama aja|sama saja|sama kak|nama saya|itu)$/i.test(t)) return 0;
    if (state.profile && state.profile.p && d.name && !d.phone && SAMA_RE.test(t)) return 1;      // "sama" setelah nama terisi = nomor yang tadi diisi di form
    if (provinceName(t) && (d.city || !/^(jakarta|bali|yogyakarta|riau|jambi|aceh|banten|lampung|bengkulu|papua|gorontalo|maluku)$/i.test(normWords(t)))) return 6;
    var looks = ADDR_HINT.test(t);
    if (!d.name && !looks && checkName(t).ok) return 0;
    if (!d.addr && (looks || d.city)) return 3;
    if (!d.city) return 5;
    if (!d.addr) return 3;
    return -1;
  }
  /* Membaca SATU pesan tanpa label yang memuat beberapa data sekaligus, mis. "ryan 0823... - Jl. Kenari 12 - Surabaya - 60127".
     Urutan: email, nomor HP, kode pos diambil dulu dari pola angkanya; sisanya dipotong per pemisah (" - ", koma, titik koma, "|") lalu ditebak:
     kata depan alamat (jl, gang, rt, angka) = alamat, huruf saja sebelum alamat = nama, huruf saja sesudah alamat = kota (dua = kecamatan lalu kota).
     Hanya dipakai bila ada minimal 2 isian yang berhasil dibaca; kalau tidak, pakai tebakan lama (guessIdx). */
  var ADDR_START = /(^|\s)(jl|jln|jalan|gg|gang|komplek|kompleks|perum|perumahan|dusun|desa)(?=[\s.])/i;
  var ADMIN_WORD = /^(kel|kelurahan|desa|kec|kecamatan|dusun|blok|komplek|kompleks|perum|perumahan|rt|rw|no|nomor|depan|samping|belakang|dekat|dkt|seberang|sebelah|gang|gg|lantai|lt|ruko|apartemen|apt|tower|patokan|area|kawasan|jalan|jl|jln|deket|pagar|rumah|toko|warung|masjid|musholla|sekolah|kantor)\b/i;
  function smartLoose(text) {
    var t = ' ' + cleanLine(text, 300) + ' ', out = [], d = {}, m;
    m = /(^|\s)([^\s@]{1,64}@[^\s@.]+(?:\.[^\s@.]+)+)(?=\s|$)/.exec(t);
    if (m) { d.email = m[2]; t = t.replace(m[2], ' | '); }
    m = /(^|[^\d])((?:\+62|62|0)[\s\-]?8\d{7,11})(?!\d)/.exec(t) || /(^|[^\d])((?:\+62|62|0)[\s\-]?8\d{1,3}(?:[\s\-.]\d{3,4}){2,3})(?!\d)/.exec(t);
    if (m) { var cp = checkPhone(m[2]); if (cp.ok && cp.value) { d.phone = m[2]; t = t.replace(m[2], ' | '); } }
    var zr = /(^|[^\d])(\d{5})(?!\d)/g, zm, zl = null;
    while ((zm = zr.exec(t))) zl = zm;
    if (zl) { d.zip = zl[2]; t = t.slice(0, zl.index + zl[1].length) + ' | ' + t.slice(zl.index + zl[1].length + 5); }
    var segs = t.split(/\s*(?:[|\n;,]|\s[-–—]\s)\s*/).map(function (s) { return s.replace(/^[\s\-–—,;|]+|[\s\-–—,;|]+$/g, ''); }).filter(Boolean);
    var addr = '', L = [], first = true;
    segs.forEach(function (s) {
      var pm;
      if (first && !addr && ADDR_START.test(s)) {                               // tanpa pemisah: "ryan Jl. Kenari 12 Surabaya" -> nama dipotong di kata depan alamat
        var am = ADDR_START.exec(s), head = s.slice(0, am.index).trim();
        if (head && head.split(' ').length <= 5 && /^[A-Za-z .'\-]+$/.test(head) && checkName(head).ok) { d.name = head; s = s.slice(am.index).trim(); }
      }
      first = false;
      if ((pm = /^(kecamatan|kec)\b\.?\s*(.+)$/i.exec(s))) { d.district = pm[2]; return; }
      if ((pm = /^(kota|kabupaten|kab)\b\.?\s*(.+)$/i.exec(s))) { d.city = pm[2]; return; }
      if (ADDR_HINT.test(s)) { addr = addr ? addr + ', ' + s : s; return; }
      if (!d.name && !addr && /^[A-Za-z .'\-]+$/.test(s) && s.split(' ').length <= 5 && checkName(s).ok) { d.name = s; return; }
      if (ADMIN_WORD.test(s)) { addr = addr ? addr + ', ' + s : s; return; }       // patokan seperti "dekat masjid" tetap bagian alamat, bukan kota
      if (/^[A-Za-z .'\-]+$/.test(s)) L.push(s);
    });
    if (!d.city && !L.length && addr) {                                         // satu potongan "Jl. Kenari 12 Surabaya": kata sesudah angka terakhir = kota (kecuali kata alamat seperti "Kelurahan", "Blok")
      var tk = addr.split(' '), li = -1, i;
      for (i = 0; i < tk.length; i++) if (/\d/.test(tk[i])) li = i;
      if (li >= 0 && li < tk.length - 1) {
        var rest = tk.slice(li + 1).join(' ').replace(/^(kota|kabupaten|kab\.?)\s+/i, '');
        if (rest && rest.split(' ').length <= 3 && /^[A-Za-z .'\-]+$/.test(rest) && !ADMIN_WORD.test(rest)) { addr = tk.slice(0, li + 1).join(' '); L.push(rest); }
      }
    }
    if (L.length && provinceName(L[L.length - 1]) && (L.length >= 2 || d.city || !/^(jakarta|bali|yogyakarta|riau|jambi|aceh|banten|lampung|bengkulu|papua|gorontalo|maluku)$/i.test(normWords(L[L.length - 1])))) d.prov = L.pop();
    if (L.length && !d.city) d.city = L.pop();
    if (L.length && !d.district) d.district = L.pop();
    if (L.length) addr = addr ? addr + ', ' + L.join(', ') : L.join(', ');
    if (d.name) out.push({ idx: 0, val: d.name });
    if (d.phone) out.push({ idx: 1, val: d.phone });
    if (d.email) out.push({ idx: 2, val: d.email });
    if (addr) out.push({ idx: 3, val: addr });
    if (d.district) out.push({ idx: 4, val: d.district });
    if (d.city) out.push({ idx: 5, val: d.city });
    if (d.prov) out.push({ idx: 6, val: d.prov });
    if (d.zip) out.push({ idx: 7, val: d.zip });
    return out;
  }
  function shipApply(S, text) {
    var sp = splitFields(text), res = { ok: [], bad: [] };
    function put(idx, val) {
      var r = SHIP_STEPS[idx].parse(val);
      if (!r.ok) { res.bad.push(r.msg); return; }
      for (var k in r.set) if (Object.prototype.hasOwnProperty.call(r.set, k)) S.d[k] = r.set[k];
      res.ok.push(idx);
    }
    sp.labeled.forEach(function (f) { if (f.val !== '') put(f.idx, f.val); });
    var sm = sp.loose && !SKIP_RE.test(sp.loose) && !LOOSE_NOISE.test(sp.loose) ? smartLoose(sp.loose) : [];
    if (sm.length >= 2) {
      sm.forEach(function (f) { put(f.idx, f.val); });
    } else if (sp.loose) {
      var gi = guessIdx(sp.loose, S);
      if (gi >= 0) put(gi, sp.loose);
      else if (gi === -1 && !sp.labeled.length) res.bad.push('Aku belum tahu itu untuk isian yang mana, Kak. Tulis dengan label ya, contoh: "Kecamatan: Gubeng".');
    }
    return res;
  }
  /* Keranjang Shopify tersimpan per browser, bukan per chat: produk sisa tes/obrolan lama ikut ke checkout. Karena itu isi keranjang ditampilkan apa adanya,
     dibandingkan dengan pesanan di chat ini (state.ledger), dan customer ditawari membersihkannya. Keranjang tidak diubah tanpa jawaban customer. */
  function fetchCart() {
    return timeoutFetch(shopRoot() + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }, 6000)
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
  }
  function ledgerCount() { var n = 0; for (var k in state.ledger) if (Object.prototype.hasOwnProperty.call(state.ledger, k)) n++; return n; }
  function cartExtras(cart) {
    var out = [];
    if (!ledgerCount() || !cart || !Array.isArray(cart.items)) return out;
    cart.items.forEach(function (it) {
      var l = state.ledger[String(it.variant_id)], want = l ? l.q : 0, have = Number(it.quantity) || 0;
      if (have > want) out.push({ it: it, want: want });
    });
    return out;
  }
  function cartText(cart, intro, flag) {
    var items = Array.isArray(cart.items) ? cart.items : [], lines = [], mark = flag !== false && ledgerCount() > 0;
    items.slice(0, 12).forEach(function (it) {
      var t = cleanLine(it.product_title || it.title || 'Produk', 80), q = Number(it.quantity) || 1;
      var line = '• ' + q + '× ' + t;
      if (it.original_line_price != null && isFinite(Number(it.original_line_price))) line += ' (' + money(Number(it.original_line_price) / 100) + ')';
      if (mark) {
        var l = state.ledger[String(it.variant_id)], want = l ? l.q : 0;
        if (q > want) line += want ? ' [pesanan di chat ini: ' + want + '×]' : ' [bukan dari chat ini]';
      }
      lines.push(line);
    });
    if (items.length > lines.length) lines.push('• dan ' + (items.length - lines.length) + ' produk lain');
    var s = intro + '\n' + lines.join('\n');
    if (cart.original_total_price != null && isFinite(Number(cart.original_total_price))) s += '\nTotal produk: ' + money(Number(cart.original_total_price) / 100) + ' (diskon dan ongkir dihitung di checkout).';
    return s;
  }
  function shipCleanAsk() {
    var S = state.ship; if (S) S.clean = true;
    shipInputMode('text');
    sbubble('Isi keranjang itu belum sama dengan pesanan di chat ini, Kak. Mau kubersihkan supaya isinya hanya pesanan di chat ini? Ketik "bersihkan" untuk membersihkan, atau "biarkan" kalau semuanya memang mau ikut dibeli.');
  }
  function shipCleanFail(S) {
    if (state.ship !== S) return;
    S.busy = false;
    sbubble('Maaf, keranjangnya belum berhasil kubersihkan semuanya. Hapus sendiri lewat ikon keranjang di pojok atas, lalu ketik "lanjut".');
  }
  function shipCleanDo(S) {
    S.busy = true;
    var extras = cartExtras(S.cart);
    extras.reduce(function (p, x) {
      return p.then(function () {
        return timeoutFetch(shopRoot() + 'cart/change.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: String(x.it.key || x.it.variant_id), quantity: x.want })
        }, 10000).then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); });
      });
    }, Promise.resolve()).then(fetchCart).then(function (cart) {
      if (state.ship !== S) return;
      S.busy = false; S.cart = cart; refreshCartUi(false);
      if (!Array.isArray(cart.items) || !cart.items.length) {
        shipEnd(); sbubble('Keranjangnya sekarang kosong, Kak. Sebutkan dulu produk yang mau dipesan ya.');
        report('checkout_prefill', { ok: false, error: 'empty_cart' });
        return;
      }
      if (cartExtras(cart).length) { shipCleanFail(S); return; }
      sbubble(cartText(cart, 'Sudah bersih. Isi keranjang sekarang:'));
      shipChoose();
    }).catch(function () { shipCleanFail(S); });
  }
  function shipCleanHandle(S, text) {
    var t = normWords(text);
    if (/^(bersihkan|bersihin|bersih|hapus|hapus saja|hapus aja|ya|iya|yap|ok|oke|sip|gas|boleh|silakan|ya bersihkan|ya hapus)$/.test(t)) { shipCleanDo(S); return true; }
    if (/^(biarkan|biarin|biar saja|biar aja|tetap|jangan|jangan dihapus|tidak|nggak|gak|ga|lanjut|semua|semuanya|ikut semua|ya semua|tidak usah|gak usah)$/.test(t)) { S.keep = true; shipChoose(); return true; }
    sbubble('Ketik "bersihkan" untuk membersihkan keranjang, atau "biarkan" kalau semua isinya memang mau ikut dibeli.');
    return true;
  }
  function shipRecap() {
    var S = state.ship, d = S.d;
    if (S.timer) { clearTimeout(S.timer); S.timer = null; }
    S.busy = true; shipInputMode('text');
    var addr = [d.addr, d.district ? 'Kec. ' + d.district : '', d.city, d.provShow, d.zip].filter(Boolean).join(', ');
    var head = 'Cek dulu ya, Kak:\nNama: ' + d.name + '\nHP: ' + d.phoneShow + '\nEmail: ' + (d.email || '-') + '\nAlamat: ' + addr;
    fetchCart().catch(function () { return S.cart || null; }).then(function (cart) {
      if (state.ship !== S) return;
      S.busy = false;
      if (cart && Array.isArray(cart.items) && !cart.items.length) {
        shipEnd(); sbubble('Keranjangnya sekarang kosong, Kak. Sebutkan dulu produk yang mau dipesan ya.');
        report('checkout_prefill', { ok: false, error: 'empty_cart' });
        return;
      }
      S.recap = true; S.clean = false; S.editing = false; if (cart) S.cart = cart;
      bubble('bot', head);
      wlog('bot', 'Cek dulu ya, Kak: ringkasan data pengiriman (nama, HP, email, alamat) ditampilkan di widget. Isinya tidak disimpan di Paijo.');
      if (S.cart && Array.isArray(S.cart.items) && S.cart.items.length) sbubble(cartText(S.cart, 'Isi keranjang:', !S.keep));
      sbubble('Sudah benar? Ketik "ya" untuk buka checkout yang sudah terisi. Kalau ada yang salah, ketik "ubah alamat" (atau nama, hp, email, kecamatan, kota, provinsi, kode pos), atau "ulang" untuk mengisi dari awal.');
    });
  }
  function checkoutUrl(d) {
    var q = [];
    function add(k, v) { if (v) q.push(encodeURIComponent(k) + '=' + encodeURIComponent(v)); }
    add('checkout[email]', d.email);
    add('checkout[shipping_address][first_name]', d.first);
    add('checkout[shipping_address][last_name]', d.last);
    add('checkout[shipping_address][address1]', d.addr);
    add('checkout[shipping_address][address2]', d.district ? 'Kec. ' + d.district : '');
    add('checkout[shipping_address][city]', d.city);
    add('checkout[shipping_address][country]', 'Indonesia');
    add('checkout[shipping_address][province]', d.prov);
    add('checkout[shipping_address][zip]', d.zip);
    add('checkout[shipping_address][phone]', d.phone);
    return shopRoot() + 'checkout' + (q.length ? '?' + q.join('&') : '');
  }
  function showCheckoutLinks(url) {
    var inner = el('div', 'pw-bubble');
    var a = el('a', 'pw-textlink', 'Checkout sekarang'); a.href = url; inner.appendChild(a);
    var b = el('div', 'pw-msg pw-bot'); b.appendChild(botGutter()); b.appendChild(inner);
    ui.log.appendChild(b); scrollDown();
  }
  function shipFinish() {
    var url = checkoutUrl(state.ship.d);
    shipEnd();
    sbubble('Beres, Kak! Ini link pembayarannya, datanya sudah terisi. Tinggal pilih kurir lalu bayar, dan alamatnya masih bisa dicek lagi di sana.');
    showCheckoutLinks(url);
    wlog('bot', '[Tautan "Checkout sekarang" ditampilkan. Data pengiriman ikut terisi di tautan itu dan tidak disimpan di Paijo.]');
    report('checkout_prefill', { ok: true });
  }
  function shipAbort(msg, why) {
    shipEnd();
    sbubble(msg);
    showLinks([{ type: 'cart' }, { type: 'checkout' }]);
    report('checkout_prefill', { ok: false, error: why });
  }
  function shipResume(S) {
    if (S.recap) shipRecap();
    else if (S.clean) shipCleanAsk();
    else if (S.editing) shipAsk();
    else if (S.steps) shipNextStep('Lanjut ya, Kak.');
    else shipChoose('Lanjut ya, Kak.');
  }
  function startShip() {
    if (state.ship) { state.ship.paused = false; shipResume(state.ship); return Promise.resolve(); }
    if (CFG.mode === 'mock') { showLinks([{ type: 'cart' }, { type: 'checkout' }]); return Promise.resolve(); }
    return timeoutFetch(shopRoot() + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }, 10000)
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || !cart.items.length) {
          sbubble('Keranjangnya kelihatannya masih kosong, Kak. Sebutkan dulu produk yang mau dipesan ya.');
          report('checkout_prefill', { ok: false, error: 'empty_cart' });
          return;
        }
        var S = newShip(cart); state.ship = S;
        sbubble(cartText(cart, 'Isi keranjang Kakak sekarang:'));
        if (cartExtras(cart).length) shipCleanAsk(); else shipChoose();
      }, function () {
        shipAbort('Aku belum bisa membaca keranjangnya sekarang. Silakan lanjut lewat tautan di bawah dan isi datanya di halaman checkout ya.', 'cart_unreadable');
      });
  }
  function shipPausedHint() {
    if (!state.ship || !state.ship.paused || state.ship.hinted) return;
    state.ship.hinted = true;
    sbubble('Kalau mau lanjut isi data pengiriman, ketik "lanjut" ya, Kak.');
  }
  /* Mengembalikan true bila ketikan sudah ditangani pengisian data (tidak diteruskan ke obrolan biasa). */
  var FIELD_LABELS = ['Nama', 'HP', 'Email', 'Alamat', 'Kecamatan', 'Kota', 'Provinsi', 'Kode pos'];
  var SHIP_CMD_RE = /^(bersihkan|bersihin|bersih|hapus|hapus saja|hapus aja|boleh|silakan|ya bersihkan|ya hapus|biarkan|biarin|biar saja|biar aja|tetap|jangan|jangan dihapus|tidak|nggak|gak|ga|semua|semuanya|ikut semua|ya semua|tidak usah|gak usah|ulang|ulangi|dari awal|isi ulang)$/;
  var SHIP_EDIT_RE = /^(ubah|ganti|edit|koreksi|revisi|perbaiki)\s+(nama|penerima|hp|no hp|nomor hp|telepon|telpon|telp|wa|whatsapp|nomor|email|alamat|jalan|kecamatan|kec|kota|kabupaten|kab|provinsi|prov|kode ?pos|pos|zip)$/;
  var CHOICE_STEP_RE = /^(1|satu|satu satu|satu-satu|satu per satu|1 per 1|di sini|disini|di chat|di chat ini|chat|isi di sini|isi disini|isi di chat|ya|iya|oke|ok|sip|gas|boleh)$/;
  var CHOICE_LINK_RE = /^(2|dua|link|di link|link payment|link pembayaran|payment|pembayaran|bayar|shopify|di shopify|isi sendiri|sendiri|checkout|link checkout|di checkout|isi di checkout|isi di link|isi di shopify|isi manual)$/;
  /* Ke monitoring: kata perintah (ya, batal, ubah alamat, ...) apa adanya; selain itu hanya nama kolom yang terisi, tidak pernah isinya. */
  function shipLogUser(text, idxs) {
    var t = normWords(text);
    if (SHIP_YES_RE.test(t) || SHIP_CANCEL_RE.test(text) || SHIP_RESUME_RE.test(text) || SHIP_CMD_RE.test(t) || SHIP_EDIT_RE.test(t) || SKIP_RE.test(text)) { wlog('user', text); return; }
    var names = (idxs || []).filter(function (v, i, a) { return a.indexOf(v) === i; }).map(function (i) { return FIELD_LABELS[i]; }).filter(Boolean);
    wlog('user', names.length ? '[Data pengiriman diisi: ' + names.join(', ') + '. Isinya tidak disimpan]' : '[Jawaban lain. Isinya tidak disimpan]');
  }
  function shipHandle(text) {
    var S = state.ship;
    if (S.busy) { ui.input.value = ''; autosize(); return true; }          // sedang memeriksa/membersihkan keranjang: abaikan ketikan sepersekian detik ini
    if (S.paused) {
      if (!SHIP_RESUME_RE.test(text)) return false;                     // masih ngobrol biasa
      ui.input.value = ''; autosize();
      bubble('user', text); wlog('user', text);
      S.paused = false; S.hinted = false;
      shipResume(S);
      return true;
    }
    if (SHIP_CANCEL_RE.test(text)) {
      ui.input.value = ''; autosize(); bubble('user', text); wlog('user', text);
      shipAbort('Siap, Kak. Silakan isi sendiri di halaman checkout ya.', 'skipped');
      return true;
    }
    if (/\?\s*$/.test(text) || /\b(admin|manusia|operator)\b/i.test(text)) {   // pertanyaan / minta admin: dijawab obrolan biasa, pengisian dijeda
      S.paused = true; S.hinted = false; shipInputMode('text');
      if (S.timer) { clearTimeout(S.timer); S.timer = null; }
      return false;
    }
    ui.input.value = ''; autosize();
    bubble('user', text);
    if (S.clean) { shipLogUser(text, []); return shipCleanHandle(S, text); }
    if (S.recap) {
      var t = normWords(text);
      var lab2 = splitFields(text).labeled;
      if (lab2.length) shipLogUser(text, lab2.map(function (f) { return f.idx; })); else shipLogUser(text, []);
      if (/^(ulang|ulangi|dari awal|isi ulang)$/.test(t)) { state.ship = newShip(S.cart); state.ship.keep = S.keep; shipNextStep('Oke, kita isi dari awal ya, Kak.'); return true; }
      if (SHIP_YES_RE.test(t)) { shipFinish(); return true; }
      var m = /^(ubah|ganti|edit|koreksi|revisi|perbaiki)\s+(.+)$/.exec(t);
      if (m) {
        for (var i = 0; i < SHIP_FIELD_ALIAS.length; i++) {
          if (SHIP_FIELD_ALIAS[i][0].test(m[2])) { S.recap = false; S.editing = true; S.step = SHIP_FIELD_ALIAS[i][1]; shipAsk(); return true; }
        }
      }
      if (splitFields(text).labeled.length) {                         // koreksi langsung berlabel, mis. "Kota: Malang"
        var r2 = shipApply(S, text);
        if (r2.bad.length) sbubble(r2.bad.join('\n'));
        shipRecap();
        return true;
      }
      sbubble('Ketik "ya" kalau datanya sudah benar. Kalau ada yang salah, ketik "ubah alamat" (atau nama, hp, email, kecamatan, kota, provinsi, kode pos), atau tulis langsung, contoh: "Kota: Malang".');
      return true;
    }
    if (S.editing) {
      var sp = splitFields(text), v = text;
      shipLogUser(text, [S.step]);
      sp.labeled.forEach(function (f) { if (f.idx === S.step && f.val) v = f.val; });
      var res = SHIP_STEPS[S.step].parse(v);
      if (!res.ok) { sbubble(res.msg + '\n\n(Ketik "batal" kalau mau isi sendiri di halaman checkout.)'); return true; }
      for (var k in res.set) if (Object.prototype.hasOwnProperty.call(res.set, k)) S.d[k] = res.set[k];
      S.editing = false; shipRecap();
      return true;
    }
    if (S.choose) {
      var tc = normWords(text);
      if (CHOICE_LINK_RE.test(tc)) { wlog('user', text); shipAbort('Siap, Kak. Silakan isi sendiri di halaman checkout ya.', 'skipped'); return true; }
      if (CHOICE_STEP_RE.test(tc)) { wlog('user', text); shipNextStep('Oke, kita isi satu per satu ya, Kak.'); return true; }
      wlog('user', '[Jawaban di luar pilihan. Isinya tidak disimpan]');
      sbubble('Ketik 1 kalau mau diisi satu per satu di sini, atau 2 kalau mau isi sendiri di link pembayaran.');
      return true;
    }
    /* satu per satu */
    var spx = splitFields(text);
    var smx = !spx.labeled.length && !SKIP_RE.test(text) && !LOOSE_NOISE.test(text) ? smartLoose(text) : [];
    var smNew = smx.filter(function (f) { return S.d[SHIP_STEPS[f.idx].k] === undefined; });
    if (spx.labeled.length || (smx.length >= 2 && smNew.length === smx.length)) {   // jawaban berlabel, atau satu pesan berisi beberapa isian yang semuanya masih kosong: baca semuanya (isian yang sudah terisi tidak pernah ditimpa tebakan)
      var ap = shipApply(S, text);
      shipLogUser(text, ap.ok);
      if (ap.bad.length) sbubble(ap.bad.join('\n'));
      shipNextStep();
      return true;
    }
    var st = SHIP_STEPS[S.step];
    if (SKIP_RE.test(text) && !st.optional) {
      wlog('user', text);
      sbubble('Yang ini perlu diisi supaya pesanan bisa dikirim, Kak. Kalau mau isi sendiri di link pembayaran, ketik "batal".\n\n' + st.ask());
      return true;
    }
    var rs = (S.step === 4 || S.step === 5) && /\d/.test(text) ? { ok: false, msg: 'Isinya cukup nama tempatnya saja, jangan pakai angka ya, Kak.' } : st.parse(text);
    if (SKIP_RE.test(text)) wlog('user', text); else wlog('user', (rs.ok ? '[Data pengiriman diisi: ' : '[Jawaban belum sesuai untuk: ') + FIELD_LABELS[S.step] + '. Isinya tidak disimpan]');
    if (!rs.ok) { sbubble(rs.msg + '\n\n(Ketik "batal" kalau mau isi sendiri di link pembayaran.)'); return true; }
    for (var kk in rs.set) if (Object.prototype.hasOwnProperty.call(rs.set, kk)) S.d[kk] = rs.set[kk];
    shipNextStep();
    return true;
  }

  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function pauseFor(txt) { var base = Number(CFG.pauseMs) || 0; return base <= 0 ? 0 : Math.min(1500, Math.round(base * 0.5 + String(txt).length * 8)); }

  /* Customer boleh mengirim beberapa gelembung berturut-turut. Setiap gelembung langsung tampil,
     lalu Paijo menunggu replyDelayMs (3 detik) sejak gelembung terakhir dan membalas semuanya dalam satu giliran. */
  function submit(forced) {
    var text = String(forced != null ? forced : ui.input.value).replace(/\s+/g, ' ').trim();
    if (!text) return;
    text = text.slice(0, CFG.maxLen);
    if (state.ship && shipHandle(text)) return;                 // sedang mengisi data pengiriman: jawaban ditangani di browser (tidak masuk riwayat, tidak ke server)
    var queued = state.queue.join('. ').length;
    if (state.queue.length && queued + text.length + 2 > CFG.maxLen) flush();     // batas 500 karakter per giliran: kirim yang sudah menumpuk dulu
    state.lastSendAt = Date.now();
    ui.input.value = ''; autosize();
    var userEl = bubble('user', text);
    state.queue.push(text); state.lastUserEl = userEl;
    state.history.push({ r: 'user', t: text }); saveHistory();
    clearTimeout(state.qTimer);
    var d = Number(CFG.replyDelayMs) || 0;
    if (d <= 0) flush(); else state.qTimer = setTimeout(flush, d);
  }

  function flush() {
    clearTimeout(state.qTimer); state.qTimer = null;
    if (!state.queue.length) return;
    if (state.pending) { state.again = true; return; }       // masih membalas giliran sebelumnya: lanjut begitu selesai
    var parts = state.queue.splice(0), userEl = state.lastUserEl;
    // Satu gelembung dikirim apa adanya; beberapa gelembung disambung dengan tanda baca supaya batas antarpesan tetap jelas ("glenfiddich 12. 1 botol").
    var text = parts.length === 1 ? parts[0] : parts.map(function (t) { return /[.!?,;:]$/.test(t) ? t : t + '.'; }).join(' ').slice(0, CFG.maxLen);
    state.pending = true;
    typing(true);
    askServer(text).then(function (data) {
      typing(false);
      showDebug(userEl, data.meta);
      if (typeof data.reply_id === 'number' && data.reply_id > 0) state.seen[Math.floor(data.reply_id)] = 1;   // sudah tampil langsung: jangan ditampilkan lagi oleh polling
      setMode(data.mode);
      if (data.mode === 'human' && !data.reply) {           // mode admin: Paijo diam, admin yang akan membalas
        if (!state.humanNoted) { state.humanNoted = true; sbubble('Pesanmu sudah diterima. Admin Tipsy Tales akan membalas di sini ya kak.'); }
        saveHistory();
        return;
      }
      if (data.mode === 'human') state.humanNoted = true;
      var reply = typeof data.reply === 'string' && data.reply ? data.reply.slice(0, 2000) : 'Hmm, aku belum nangkep maksudnya. Bisa dijelasin lagi?';
      var prods = (Array.isArray(data.products) ? data.products : []).slice(0, 6).map(safeProduct).filter(Boolean);
      // Balasan panjang dipecah per paragraf jadi beberapa gelembung (seperti orang mengetik). Bila ada aksi keranjang,
      // paragraf pertama tampil dulu, lalu "✓ sudah masuk keranjang", baru sisanya ("mau tambah lagi?") supaya urutannya wajar.
      var paras = reply.split(/\n{2,}/).map(function (t) { return t.trim(); }).filter(Boolean);
      if (!paras.length) paras = [reply];
      if (paras.length > 5) paras = paras.slice(0, 4).concat([paras.slice(4).join('\n\n')]);
      var first = paras[0], rest = paras.slice(1);
      bubble('bot', first); showProducts(prods);
      state.history.push({ r: 'bot', t: first, p: prods.map(function (p) {
        return { handle: p.handle, title: p.title, price: p.price, image: p.image, variant_id: p.variantId, available: p.available };
      }) });
      saveHistory();
      var chain = runActions(data.actions);
      rest.forEach(function (t) {
        chain = chain.then(function () {
          typing(true);
          return wait(pauseFor(t)).then(function () {
            typing(false);
            bubble('bot', t); state.history.push({ r: 'bot', t: t }); saveHistory();
          });
        });
      });
      return chain.then(function () {
        if (data.ship === true) return startShip();
        showLinks(data.links);
        if (state.ship && state.ship.paused) shipPausedHint();
      });
    }).catch(function (err) {
      typing(false);
      errorBubble(err && err.userMessage ? err.userMessage : 'Maaf, Paijo lagi gangguan. Coba kirim lagi sebentar lagi ya.');
    }).then(function () {
      state.pending = false;
      if (state.again && state.queue.length) { state.again = false; flush(); }
      else state.again = false;
    });
  }

  /* ---------- start ---------- */
  function mount() {
    build();
    host.style.display = 'none';
    function reveal() {
      if (!ageGatePassed()) return false;
      host.style.display = '';
      return true;
    }
    if (!reveal()) {
      var iv = setInterval(function () { if (reveal()) clearInterval(iv); }, 1000);
    }
    watchViewport();
    watchLift();
    reschedulePoll();
    var pend = pendingTake();                    // halaman berpindah saat memasukkan ke keranjang: beri tahu, jangan diam
    if (pend && state.history.length) {
      var tp = 'Tadi proses memasukkan ' + pend.q + '× ' + pend.t + ' sempat terputus karena halaman berpindah. Cek ikon keranjang untuk memastikan sudah masuk, jangan langsung menambah lagi ya.';
      state.history.push({ r: 'bot', t: tp, err: true }); saveHistory();
      if (ui.log && ui.log.childNodes.length) { bubble('bot pw-error', tp); wlog('bot', tp); }
      report('add_to_cart_result', { ok: false, error: 'interrupted', qty: pend.q });
    }
  }

  window.PaijoWidget = {
    open: function () { if (host) setOpen(true); },
    close: function () { if (host) setOpen(false); },
    send: function (t) { submit(t); },
    version: '0.6.3'
  };

  function init() { if (rolloutAllowed()) mount(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
